import React from 'react'
import { Switch, Route } from 'react-router-dom'

import PrivateRoute from './component/private-route'

import IndexRoute from './route/index-route'
import DiscountRoute from './route/discount-route'
import ProcessRoute from './route/process-route'
import UserListRoute from './route/user-list-route'
import UserRoute from './route/user-route'
import LogoutRoute from './route/logout-route'
import RegistrationRoute from './route/registration-route'
import EventListRoute from './route/event-list-route'
import EventSingleRoute from './route/event-single-route'
import NewsListRoute from './route/news-list-route'
import InviteRoute from './route/invite-route'
import AchivmentRoute from './route/achivment-route'
import BotListRoute from './route/bot-list-route'
import RecommendationListRoute from './route/recommendation-list-route'
import RecommendationRoute from './route/recommendation-route'
import StatRoute from './route/stat-route'
import AboutRoute from './route/about-route'
import LoginRoute from './route/login-route'

const App = () => {
    return (
        <Switch>
            <PrivateRoute exact path='/' component={IndexRoute} />
            <PrivateRoute exact path='/process' component={ProcessRoute} />
            <PrivateRoute exact path='/process/:processId/events' component={EventListRoute} />
            <PrivateRoute exact path='/process/:processId/events/:eventId' component={EventSingleRoute} />
            <PrivateRoute exact path='/process/:processId/news' component={NewsListRoute} />
            <PrivateRoute exact path='/events' component={EventListRoute} />
            <PrivateRoute exact path='/events/:eventId' component={EventSingleRoute} />
            <PrivateRoute exact path='/about' component={AboutRoute} />
            <PrivateRoute exact path='/achivment' component={AchivmentRoute} />
            <PrivateRoute exact path='/discounts' component={DiscountRoute} />
            <PrivateRoute exact path='/people' component={UserListRoute} />
            <PrivateRoute exact path='/people/:name' component={UserRoute} />
            <PrivateRoute exact path='/logout' component={LogoutRoute} />
            <PrivateRoute exact path='/invite' component={InviteRoute} />
            <PrivateRoute exact path='/bots' component={BotListRoute} />
            <PrivateRoute exact path='/recommendation' component={RecommendationListRoute} />
            <PrivateRoute exact path='/recommendation/:recommendationId' component={RecommendationRoute} />
            <PrivateRoute path='/stat' component={StatRoute} />
            <Route exact path='/registration/:invite' component={RegistrationRoute} />
            <Route path="*" component={LoginRoute} />
        </Switch>
    )
}

export default App
